<template>
  <div class="col-10 col-md-6 align-self-center my-3 action text-center position-relative"
       :class="'bg-light-'+action.action_type_formatted.color"
  >
     <span class="fw-bold ">
          {{ action.from.fullname }} {{ action.action_type_formatted?.[locale] }} {{ action.action_content }}
        </span>
    <span class="position-absolute text-muted bottom-0 end-0 m-1 me-2">
         {{ getDateHour(action?.created_at) }}
    </span>
  </div>
</template>

<script setup>

import {ref, computed} from "vue"
import {useLocales} from "@/composables/locales";

const { locale } = useLocales()
const props = defineProps({
  action: {
    type: Object,
    required: true
  },
})

const now = ref(new Date())
const player = ref(null)
const interval = ref(null)

const isSender = computed(() => !!props.action?.is_me)


function getDateHour(date) {
  return new Date(date).toLocaleTimeString(locale.value, {
    hour: '2-digit',
    minute: '2-digit'
  })
}

</script>

<style lang="scss">

.action {
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  background-color: #0072CE0D;
  min-height: 40px;
}


</style>